/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestStepBase } from './AutoTestStepBase';
import { RubricRowBase } from './RubricRowBase';
const AutoTestSuiteParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['steps', /* #__PURE__ */ codecArray(AutoTestStepBase)],
    ['rubricRow', RubricRowBase, 'rubric_row'],
    ['networkDisabled', codecBoolean, 'network_disabled'],
    ['submissionInfo', codecBoolean, 'submission_info'],
    [
        'commandTimeLimit',
        /* #__PURE__ */ parsers.maybeNull(parsers.duration),
        'command_time_limit',
    ],
]));
export class AutoTestSuite extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return AutoTestSuiteParser.decode(input).map(res => new AutoTestSuite(res));
    }
    static unsafeDecode(input) {
        return AutoTestSuite.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AutoTestSuiteParser.encode(data);
    }
    static schema() {
        return AutoTestSuiteParser.schema();
    }
}
